import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';
import '../styles/Landing.css';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ borderTop: '1px solid var(--border)', paddingTop: 32, marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 14 }}>{title}</h2>
    <div style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.9 }}>{children}</div>
  </div>
);

const Terms = () => (
  <div className="landing-bg" style={{ minHeight: '100vh' }}>
    <div className="landing-orbs">
      <div className="orb1" /><div className="orb2" /><div className="orb3" />
    </div>

    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="nav-links">
        <Link to="/login" className="nav-a">Login</Link>
        <Link to="/register" className="btn-main" style={{ padding: '10px 22px', fontSize: 12 }}>Get Started ↗</Link>
      </div>
    </nav>

    <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 24px 60px' }}>
      <div className="tag" style={{ marginBottom: 20, display: 'inline-flex' }}>Legal</div>
      <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 12 }}>Terms & Conditions</h1>
      <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 40 }}>
        Last updated: October 2026 · Effective immediately upon account creation.
      </p>

      <Section title="1. Acceptance of Terms">
        By creating an account or using mylinx.in, you agree to these Terms & Conditions. If you do not agree, please do not use our service.
      </Section>

      <Section title="2. Description of Service">
        mylinx.in is a link-in-bio platform that allows users to create a personal profile page containing links, social media buttons, and other content. We offer both free and paid (PRO) plans.
      </Section>

      <Section title="3. Account Registration">
        <p>You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your account credentials. You must be at least 13 years old to use mylinx.in.</p>
        <br />
        <p>We reserve the right to suspend or terminate accounts that violate these terms, contain illegal content, or are used for spam or abusive purposes.</p>
      </Section>

      <Section title="4. Acceptable Use">
        <p>You agree not to use mylinx.in to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>Post illegal, harmful, or offensive content</li>
          <li style={{ marginBottom: 6 }}>Impersonate another person or entity</li>
          <li style={{ marginBottom: 6 }}>Distribute spam or malicious links</li>
          <li style={{ marginBottom: 6 }}>Violate any applicable laws or regulations</li>
          <li style={{ marginBottom: 6 }}>Engage in any activity that disrupts or interferes with our services</li>
        </ul>
      </Section>

      <Section title="5. PRO Subscription">
        <p>mylinx.in offers a PRO plan with additional features. By subscribing to PRO:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>You authorize recurring charges to your payment method</li>
          <li style={{ marginBottom: 6 }}>Subscriptions auto-renew unless cancelled before the renewal date</li>
          <li style={{ marginBottom: 6 }}>Pricing is subject to change with 30 days' notice</li>
          <li style={{ marginBottom: 6 }}>Free trial, if offered, converts to a paid subscription at end of trial</li>
        </ul>
      </Section>

      <Section title="6. Intellectual Property">
        All content on mylinx.in, including the name, logo, design, and code, is owned by mylinx. Your profile content remains your own. By using our service, you grant us a limited license to display your content as part of the platform.
      </Section>

      <Section title="7. Limitation of Liability">
        mylinx.in is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the service, including loss of data or revenue.
      </Section>

      <Section title="8. Termination">
        We may suspend or terminate your account at any time for violation of these terms. You may also delete your account at any time. Upon termination, your data will be deleted within 30 days.
      </Section>

      <Section title="9. Governing Law">
        These terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of courts in India.
      </Section>

      <Section title="10. Contact">
        For questions about these terms, contact us at{' '}
        <a href="mailto:support@mylinx.in" style={{ color: 'var(--accent)' }}>support@mylinx.in</a>.
      </Section>
    </div>

    <footer className="footer">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="footer-copy">MADE WITH OBSESSION © 2026</div>
      <div className="footer-links">
        <Link to="/about" className="footer-a">About</Link>
        <Link to="/contact" className="footer-a">Contact</Link>
        <Link to="/terms" className="footer-a">Terms</Link>
        <Link to="/privacy" className="footer-a">Privacy</Link>
        <Link to="/refund" className="footer-a">Refund</Link>
      </div>
    </footer>
  </div>
);

export default Terms;